module.exports = __webpack_public_path__ + "img/headshot5.1e48693e.jpg";